/**
 * Utility functions for image optimization, responsive resizing, and lazy loading.
 */

/**
 * Optimizes Blogger and Picsum image URLs dynamically.
 * Blogger/Google Photos CDNs support resizing by replacing or appending size tokens (e.g. /s1600/ -> /s600/).
 * 
 * @param url The original image URL
 * @param size The target size token (e.g., 's400', 's600', 's800', 's1600')
 */
export function optimizeImageUrl(url: string | undefined | null, size: string = 's600'): string {
  if (!url) return '';
  
  // Blogger / Google User Content / Blogspot CDN optimization
  if (
    url.includes('blogger.googleusercontent.com') || 
    url.includes('bp.blogspot.com') || 
    url.includes('googleusercontent.com')
  ) {
    // Matches size slugs like /s1600/, /s0/, /s320/, /s640/, /s800/, /w320/, /w640/, etc.
    const regex = /\/(s\d+|s0|w\d+|h\d+)\//i;
    if (regex.test(url)) {
      return url.replace(regex, `/${size}/`);
    }
  }

  // Picsum Photos optimization
  if (url.includes('picsum.photos')) {
    if (size === 's400') {
      return url.replace(/\/\d+\/\d+/, '/400/300');
    } else if (size === 's600') {
      return url.replace(/\/\d+\/\d+/, '/600/450');
    } else if (size === 's800') {
      return url.replace(/\/\d+\/\d+/, '/800/600');
    }
  }

  return url;
}
